import { connect } from "react-redux";
import { commonSlice, userSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";

import { Container, IframeContainer, Header, BackButton} from "./WPlayer.Style";
import { useEffect, useMemo, useState } from "react";
import { RemoteContentDetail } from "../services/contents/IContentService";
import { usePlayer } from "../services/player/usePlayer";
import Sdk from "api.digitalpages.module.sdk.api";
import { useDispatch } from "react-redux";

export interface PlayerStateProps {
  loading: boolean;
  contentUrl?: string;
  uid?: string;
  uidContext?: string;
  navigateTo?: string;
}

export interface PlayerDispatchProps {}

export type PlayerProps = PlayerStateProps & PlayerDispatchProps;

/**
 * @function Player: componente responsável por lidar com a renderização do epub.
 * @function getUri: essa função é para testes em ambiente de desenvolvimento onde o projeto rodando na porta 3001, é o js_leargning_player_react.
 */
const Player: React.FC<PlayerProps> = ({
  loading,
  contentUrl,
  uid,
  uidContext,
  navigateTo,
}) => {
  const [uri, setUri] = useState("");
  const {
    getAnnotations,
    getLastInteraction,
    lastReference,
    userData,
    lastInteraction,
  } = usePlayer(uid, uidContext);
  const dispatch = useDispatch();

  const geUri = async (uid: string) => {
    if (!contentUrl) return;
    await fetch(contentUrl).then(({ url }) => {
      const base = "http://localhost:3001/";
      const unicode = url.substring(url.indexOf("custom_options"), url.length);
      const uURI = `${base}?${unicode}`;
      setUri(`${uURI}`);
    });
  };

  const [canRenderHeader, setCanRenderHeader] = useState(false);

  useEffect(() => {
    dispatch(commonSlice.actions.setLoader(true));
  }, []);

  useEffect(() => {
    if (uid && contentUrl) {
      getAnnotations(uid).then(async () => {
        await getLastInteraction();
        setUri(contentUrl);
        // geUri(uid)
      });
    }
  }, [uid]);

  useEffect(() => {
    async function checkHeaderStatus() {

      if (!contentUrl) return;
      await fetch(contentUrl).then(({ url }) => {
        // console.log(`url: ${url}`);
        const customOptions = decodeUnicode(
          getParameterByName("custom_options", url)
        );
        var info = JSON.parse(customOptions);
        setCanRenderHeader(info.activity.mime_type === "digitalpages/audiobook");
      });
    }
     checkHeaderStatus()
  }, [contentUrl]);


  const renderHeader = () => {
    if (canRenderHeader) {
      return (
        <Header>
          <BackButton onClick={onBackButtonClick} />
        </Header>
      )
    }  
  }

  const onBackButtonClick = async () => {
    dispatch(commonSlice.actions.backPage());
  }

  const decodeUnicode = (str: any) => {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }
  
  const getParameterByName = (name: any, url: any) =>{
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  return (
    <Container>
      {uri != "" && (
        <>
          {renderHeader()}
          <IframeContainer
            onLoad={(e: any) => {
              e.target.contentWindow.postMessage(
                {
                  userData: JSON.stringify(userData),
                  lastReference,
                  navigateTo,
                  lastInteraction,
                  type: "RDPEvent:user_interaction",
                },
                "*"
              );
              dispatch(commonSlice.actions.setLoader(false));
            }}
            onError={() => {
              dispatch(commonSlice.actions.setLoader(false));
            }}
            sandbox="allow-scripts allow-forms allow-same-origin allow-pointer-lock allow-presentation allow-modals allow-popups allow-popups-to-escape-sandbox"
            allow="camera; microphone; display-capture; autoplay; clipboard-write; encrypted-media"
            src={uri}
          ></IframeContainer>
        </>
      )}
    </Container>
  );
};


const mapState = (state: RootState) => {
  var loading = state.contentState.activeContentReference == undefined;
  var url: string | undefined = undefined;

  if (!loading) {
    url = state.contentState.activeContentReference.url;
  }

  const result: PlayerStateProps = {
    navigateTo: state.contentState.activeContentAnchorLink,
    contentUrl: url,
    loading: loading,
    uidContext: state.contentState.activeContentUid,
    uid: state.contentState.activeContentReference
      ? state.contentState.activeContentReference.uid
      : "",
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PlayerDispatchProps = {
    onLogout: () => dispatch(userSlice.actions.logout()),
  };
  return result;
};

const WPlayer = connect(mapState, mapDispatch)(Player);

export { WPlayer };
